import { useEffect, useState } from 'react';
import { coreApi } from '../../../utils/axios';
import errorRoutine from '../../../utils/errorRoutine';
import { Pharmacy } from '../../../types/pharmacy';

export const usePostalPharmaciesCount = (orgId: string) => {
  const [postalPharmaciesCount, setPostalPharmaciesCount] = useState<number>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [error, setError] = useState<string>();

  useEffect(() => {
    const fetch = async () => {
      try {
        setIsLoading(true);

        const { data } = await coreApi.post<{ data: Pharmacy[] }>(
          `/pharmacies-public/search`,
          { postal_partner: true },
          {
            headers: {
              'chain-id': orgId,
            },
          }
        );
        const postalPharmacies = data.data;

        setPostalPharmaciesCount(postalPharmacies.length);
      } catch (err) {
        errorRoutine(err, setError);
        alert(err);
      } finally {
        setIsLoading(false);
        setIsLoaded(true);
      }
    };

    fetch();
  }, [orgId]);

  return { postalPharmaciesCount, isLoading, isLoaded, error };
};
